<template>
    <svg xmlns="http://www.w3.org/2000/svg" :height="size" :width="size" :fill="color" viewBox="0 -960 960 960">
        <path d="M80-200v-240q0-27 11-49t29-39v-112q0-50 35-85t85-35h160q23 0 43 8.5t37 23.5q17-15 37-23.5t43-8.5h160q50 0 85 35t35 85v112q18 17 29 39t11 49v240h-80v-80H160v80H80Zm440-360h240v-80q0-17-11.5-28.5T720-680H560q-17 0-28.5 11.5T520-640v80Zm-320 0h240v-80q0-17-11.5-28.5T400-680H240q-17 0-28.5 11.5T200-640v80Z"/>
    </svg>
</template>

<script>
  export default {
    name: 'IconBed',
    props: {
       color: {
        type: String,
        default: "#F3F3F3",
       },
       size: {
        type: String,
        default: "1rem",
       },
    }
  }
</script>